import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TabBar, TabButton } from '~/components';

export default function SubRouteSwitch({
  onChange,
  value,
  className,
  tabletMode,
  styleTab,
  localTeam,
  awayTeam,
}) {
  const { t } = useTranslation();
  if (tabletMode) {
    return (
      <TabBar
        value={value}
        onChange={onChange}
        className={className}
        styleTab={styleTab}
      >
        <TabButton value="local" label={localTeam || '--'} />
        <TabButton value="away" label={awayTeam || '--'} />
      </TabBar>
    );
  }

  return (
    <TabBar
      value={value}
      onChange={onChange}
      className={className}
      styleTab={styleTab}
    >
      <TabButton value="local" label={localTeam || t('rolHome')} />
      <TabButton value="away" label={awayTeam || t('rolAway')} />
      {!tabletMode && <TabButton value="stats" label={t('stats')} />}
    </TabBar>
  );
}

SubRouteSwitch.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  tabletMode: PropTypes.bool,
  styleTab: PropTypes.object,
  localTeam: PropTypes.string,
  awayTeam: PropTypes.string,
};

SubRouteSwitch.defaultProps = {
  onChange: () => {},
  value: '',
  className: '',
  tabletMode: false,
  styleTab: {},
  localTeam: '',
  awayTeam: '',
};
